export default {"src":"/_next/static/media/no-graph.f319567c.svg","height":24,"width":24};